import styled, { css } from 'styled-components';

const FlexColumn = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: flex-end;
    // max-width: 45%;
    flex: 1;
    flex-basis: 50%;
    // background-color: aqua;
  `
);

export { FlexColumn };
